<template>
  <nav v-if="$beet.isReady" class="navbar">
    <aside class="navbar__main">
      <RouterLink :to="{ name: 'home' }">
        <img src="@/assets/images/logo.svg" alt="Ville Éponge" class="navbar__logo" />
      </RouterLink>

      <span class="navbar__socials">{{ $beet.options.general.socials.label }}</span>

      <template v-for="key in ['facebook', 'linkedin']">
        <a
          v-if="$beet.options.general.socials[key]"
          :href="$beet.options.general.socials[key]"
          class="navbar__link -icon"
          target="_blank"
          rel="noopener"
        >
          <Icon :id="key" class="navbar__icon" />
        </a>
      </template>

      <div class="navbar__infolettre" @click.stop="$store.dispatch('openNewsletterModal')">
        <span class="navbar__infolettre-mobile">
          <Icon id="contact" class="navbar__icon" />
        </span>
        <span class="navbar__infolettre-desktop"
          >Inscrivez-vous à <span class="link">l&apos;infolettre</span></span
        >
      </div>
    </aside>

    <menu class="navbar__menu">
      <template v-if="$mq.mdPlus">
        <RouterLink class="navbar__link" :to="{ name: 'program' }">
          <Icon id="leaf" class="navbar__link-leaf" />
          À propos
        </RouterLink>

        <RouterLink class="navbar__link" :to="{ name: 'support' }">
          <Icon id="leaf" class="navbar__link-leaf" />
          Soutien
        </RouterLink>

        <RouterLink
          class="navbar__link -involve button -link -flat -corner-right"
          :to="{ name: 'involve' }"
        >
          S'impliquer
        </RouterLink>
      </template>

      <button class="burger" @click.stop="$store.dispatch('openSideNav')">
        <span class="burger__line"><Icon id="leaf" class="burger__leaf" /></span>
        <span class="burger__line -middle"><Icon id="leaf" class="burger__leaf" /></span>
        <span class="burger__line"><Icon id="leaf" class="burger__leaf" /></span>
      </button>
    </menu>
  </nav>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'NavBar',
  components: { Icon },
}
</script>
